import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import HomeView from "../views/home-view.vue";
import AboutView from "../views/about-view.vue";
import LanguageView from "../views/language-view.vue";

Vue.use(VueRouter);
Vue.use(VueMeta);
const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "About",
    component: AboutView,
  },
  {
    path: "/language",
    name: "Language",
    component: LanguageView,
  },
  { path: "*", component: HomeView },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
